import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-at-icon',
  templateUrl: './communication-mail-at.component.html'
})
export class CommunicationMailAtComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
